import React from 'react';
import { Box, Button, Card, CardContent, Stack, Typography } from '@mui/material';
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';
import { Translation } from 'react-i18next';
import { saveSupportReportDraft, supportReportPath } from '../../utils/supportReports';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    console.error('[ui:error-boundary]', error, errorInfo);
  }

  reportIssue = () => {
    const { error, errorInfo } = this.state;
    const draftId = saveSupportReportDraft({
      category: 'bug',
      pageName: 'The Tavern',
      page: window.location.pathname,
      errorType: 'Frontend runtime error',
      errorMessage: error?.message,
      stack: error?.stack || errorInfo?.componentStack,
    });

    window.location.assign(supportReportPath(draftId));
  };

  render() {
    if (!this.state.error) {
      return this.props.children;
    }

    return (
      <Translation>
        {(t) => (
          <Box
            sx={{
              minHeight: '100vh',
              display: 'grid',
              placeItems: 'center',
              px: 2,
              py: 6,
              background:
                'radial-gradient(circle at 12% 10%, rgba(215,160,75,0.22), transparent 26rem), radial-gradient(circle at 88% 72%, rgba(15,76,69,0.14), transparent 32rem)',
            }}
          >
            <Card variant="outlined" sx={{ width: '100%', maxWidth: 680 }}>
              <CardContent sx={{ p: { xs: 3, md: 5 } }}>
                <Stack spacing={2.5} alignItems="flex-start">
                  <Typography variant="subtitle2" color="secondary.dark">
                    {t('errorBoundary.eyebrow')}
                  </Typography>
                  <Typography component="h1" variant="h1" sx={{ fontSize: { xs: 34, md: 48 } }}>
                    {t('errorBoundary.title')}
                  </Typography>
                  <Typography color="text.secondary">{t('errorBoundary.copy')}</Typography>
                  <Button
                    variant="contained"
                    startIcon={<SupportAgentOutlinedIcon />}
                    onClick={this.reportIssue}
                  >
                    {t('support.reportIssue')}
                  </Button>
                </Stack>
              </CardContent>
            </Card>
          </Box>
        )}
      </Translation>
    );
  }
}

export default ErrorBoundary;
